import { ProvinceOrMetropolitan } from '../api/common/getMetropolitansAndProvinces'

export const getRegionString = (metroPole: ProvinceOrMetropolitan | null) => {
  if (!metroPole) return ''
  if (metroPole.category === 'M') {
    return metroPole?.code ?? ''
  }
  return (metroPole?.code ?? '') + ', ' + metroPole?.provinceName ?? ''
}
